import { Box as ThemeBox, ThemeUIStyleObject } from "theme-ui";
import React, { ReactNode } from "react";

type Props = {
  children?: ReactNode;
  sx?: ThemeUIStyleObject | undefined;
  as?: React.ElementType;
  name?: string;
  id?: string;
  onSubmit?: React.FormEventHandler<HTMLDivElement> | undefined;
};

export const Box: React.FC<Props> = ({
  children,
  sx,
  as,
  name,
  id,
  onSubmit,
}) => {
  return (
    <ThemeBox
      as={as}
      sx={sx}
      //@ts-ignore
      name={name}
      id={id}
      onSubmit={onSubmit}
    >
      {children}
    </ThemeBox>
  );
};
